import axios from "@/helpers/axios";
import confetti from "canvas-confetti";
import policyPopup from "@/components/modal/policyPopup/layout.vue";
import stepProgress from "vue-step-progress";
import "../progressbar.css";
import registerCardModal from "@/components/modal/RegisterCard/index.vue";
import channelTalk from "@/helpers/channelTalk";
export default {
  metaInfo: {
    title: "관리자 회원가입"
  },

  components: {
    policyPopup,
    stepProgress,
    registerCardModal
  },
  data() {
    return {
      companyName: "",
      companyNameValidate: false,
      isDuplicate: false,
      openRegisterCardModal: false,
      registeredFrom: "MODAL",

      progressLibraryOption: {
        mySteps: ["", "", "", ""],
        currentStep: 0,
        activeColor: "#0081ea",
        passiveColor: "#ecf0f3",
        lineThickness: 2
      },

      vatInfo: {
        licenseImage: ""
      },

      policyType: "",
      openPolicyPopup: false,
      isAgreePolicy: {
        service: false,
        privacy: false,
        marketing: false
      },

      checkPath: false,
      isSelectPathway: false,
      preSelect: "",

      selectJoinWay: "none",
      selectItem: [],
      step1Content: {},
      step2Content: {
        selectItem: []
      },
      step3Content: {},
      step4Content: {},
      step6Content: {},

      step: 1,

      licenseImage: "",

      deliveryItem: [
        {
          name: "서류/인쇄물",
          value: "DOC"
        },
        {
          name: "케이크",
          value: "CAKE"
        },
        {
          name: "꽃/식물",
          value: "PLANT"
        },
        {
          name: "의류/샘플",
          value: "CLOTHING"
        },
        {
          name: "전자제품",
          value: "ELECTRONICS"
        },
        {
          name: "사무용품",
          value: "OFFICESUPPLIES"
        },
        {
          name: "간편식품",
          value: "CONVENIENCEFOOD"
        },
        {
          name: "신선식품",
          value: "FRESHFOOD"
        },
        {
          name: "액체류",
          value: "LIQUID"
        }
      ],
      options: [
        {
          title: "디버를 통해 배송 받은 경험",
          ischeck: false,
          value: "EXPERIENCE"
        },
        { title: "SNS(인스타그램, 페이스북 등)", ischeck: false, value: "SNS" },
        { title: "카페/블로그", ischeck: false, value: "BLOG" },
        { title: "지인 추천", ischeck: false, value: "FRIENDS" },
        {
          title: "디버 파트너(배송원)추천",
          ischeck: false,
          value: "DVERPARTNERS"
        },
        { title: "기타", ischeck: false, value: "ETC" }
      ],
      completeCardList2: [
        {
          title: "결제카드 등록",
          subTitle: "결제 시 이용할 카드를<br/> 미리 등록해 보세요!",
          value: "card",
          imgNum: 0
        },
        {
          title: "자주묻는 질문(FAQ)",
          subTitle: "디버에게 궁금한 점이 있나요?<br/> 해결해 드릴게요!",
          value: "faq",
          imgNum: 2
        },
        {
          title: "배송운임표",
          subTitle: "디버의 합리적인 운임을<br/> 확인해 보세요!",
          value: "deliveryFee",
          imgNum: 3
        },
        {
          title: "고객센터 연결",
          subTitle: "디버의 챗봇 문의 화면으로<br/> 바로 연결해 드릴게요!",
          value: "chatbot",
          imgNum: 4
        }
      ],
      completeCardList1: [
        {
          title: "결제카드 등록",
          subTitle: "결제 시 이용할 카드를<br/> 미리 등록해 보세요!",
          value: "card",
          imgNum: 0
        },
        {
          title: "사업자정보 입력",
          subTitle: "사업자정보 입력 시<br/> 월정산 신청이 가능해요!",
          value: "companyInfo",
          imgNum: 1
        },
        {
          title: "자주묻는 질문(FAQ)",
          subTitle: "디버에게 궁금한 점이 있나요?<br/> 해결해 드릴게요!",
          value: "faq",
          imgNum: 2
        },
        {
          title: "배송운임표",
          subTitle: "디버의 합리적인 운임을<br/> 확인해 보세요!",
          value: "deliveryFee",
          imgNum: 3
        }
      ],

      isLoading: false,
      fileUploadProcess: "첨부파일이 없습니다.",
      requireInfoAllPass: true,
      isAllPass: true,
      passAgree: true,

      imageLoading: false,

      carrier: {
        value: "",
        ischeck: false
      }
    };
  },
  watch: {
    step(newVal) {
      if (newVal === 5 || newVal === 7) {
        const myCanvas = document.getElementById("complete");
        const myConfetti = confetti.create(myCanvas, {
          resize: true,
          useWorker: true
        });

        myConfetti({
          particleCount: 50,
          spread: 80,
          origin: {
            y: 0.7
          }
        });
      }
    },
    companyName(newVal) {
      this.checkDuplicate(newVal);
    }
  },
  computed: {
    isAllCheck() {
      if (
        !this.isAgreePolicy.service ||
        !this.isAgreePolicy.privacy ||
        !this.isAgreePolicy.marketing
      )
        return false;

      return true;
    },
    showDuplicateHelperText() {
      //유효성 통과 후 중복일 경우에만 문구 노출
      const isError = this.companyNameValidate.hasErrors; //유효성 통과여부
      return isError !== undefined && !isError && this.isDuplicate;
    }
  },
  methods: {
    async setCompanyName(e) {
      if (
        this.companyNameValidate.hasErrors ||
        this.companyNameValidate.hasErrors === undefined
      )
        return;
      this.companyName = e.target.value;
    },
    async checkDuplicate(companyName) {
      try {
        const result = await this.$store.dispatch("users/getExistCompanyName", {
          companyName: companyName
        });
        this.isDuplicate = result.success && result.result.length !== 0;
      } catch (e) {}
    },
    cardList() {
      let list;
      this.step === 5
        ? (list = this.completeCardList1)
        : (list = this.completeCardList2);
      return list;
    },
    checkAll() {
      const values = Object.values(this.isAgreePolicy);

      const isAllTrue = values.every(function (value) {
        return value;
      });

      Object.keys(this.isAgreePolicy).forEach(
        (key) => (this.isAgreePolicy[key] = isAllTrue ? false : true)
      );
    },

    customTrim(value) {
      value = value.replace(/ +/g, " ");
      value = value.replace(/^\s+|\s+$/g, "");
      return value;
    },
    trimOnBlur(key) {
      if (key === "id") {
        this.step4Content.userId = this.step4Content.userId.replace(/\s/g, "");
      } else {
        this.vatInfo[key] = this.vatInfo[key].replace(/ +/g, " ");
        this.vatInfo[key] = this.vatInfo[key].replace(/^\s+|\s+$/g, "");
      }
    },

    routeOrderPage() {
      this.$router.push("/orders/form");
    },

    async submitVatInfo() {
      const payload = {
        vatInfo: this.vatInfo
      };

      try {
        const result = await this.$store.dispatch(
          "users/changeVatInformation",
          payload
        );
        if (!result.success) {
          console.error(result);
        }
        return (
          (this.step = this.step + 1), channelTalk.boot(), window.scrollTo(0, 0)
        );
      } catch (e) {
        alert("회원가입중 오류가 발생하였습니다");
      }
    },
    //ID 중복 체크 및 회원가입 로직 실행
    async checkExistUser() {
      this.isLoading = true;
      try {
        const result = await this.$store.dispatch(
          "checkId",
          this.step4Content.userId
        );
        if (result.existingUser === "NNNNY") {
          alert("이미 사용 중인 아이디에요.");
          this.isLoading = false;
          return false;
        }
        return this.submit();
      } catch (e) {
        alert("회원가입중 오류가 발생하였습니다");
      }
    },

    //회원가입 로직
    async submit() {
      let concatFrequentSendGoods = [];
      concatFrequentSendGoods = concatFrequentSendGoods.concat(
        this.step2Content.selectItem
      );
      if (this.step2Content.frequentSendGoods) {
        concatFrequentSendGoods.push(this.step2Content.frequentSendGoods);
      }

      let subscriptionList = [];
      if (this.selectJoinWay === "ETC") {
        if (this.step3Content.etc) {
          subscriptionList.push("기타(" + this.step3Content.etc + ")");
        } else subscriptionList = ["기타"];
      } else {
        subscriptionList.push(this.selectJoinWay);
      }

      const payload = {
        vatInfo: {
          companyName: this.step1Content.companyName,
          recommender: this.step3Content.recommender
            ? this.step3Content.recommender
            : null
        },
        name: this.step1Content.name,
        phoneNumber: this.step1Content.phoneNumber,
        frequentSendGoods: concatFrequentSendGoods,
        subscriptionPath: subscriptionList,
        previousDeliveryPlatform: this.carrier.ischeck
          ? "NONE"
          : this.step3Content.previousDeliveryPlatform,
        userId: this.step4Content.userId,
        password: this.step4Content.password,
        isAgreedToService: this.isAgreePolicy.service,
        isAgreedToPrivacyPolicy: this.isAgreePolicy.privacy,
        isAgreedToMarketing: this.isAgreePolicy.marketing
      };

      try {
        const result = await this.$store.dispatch("biz_master_signup", payload);
        if (!result.success) {
          this.isLoading = false;
          if (result.code === 409) {
            return alert("이미 존재하는 아이디입니다.");
          }
          return alert("요청에 오류가 발생하였습니다");
        } else {
          this.$store.dispatch("auth/updateAccessToken", result.accessToken);
          this.$store.dispatch("auth/updateRefreshToken", result.refreshToken);
        }
        return (
          (this.step = this.step + 1),
          window.scrollTo(0, 0),
          (this.isLoading = false)
        );
      } catch (e) {
        alert("회원가입중 오류가 발생하였습니다");
      }
    },
    openPolicy(type) {
      this.policyType = type;
      this.openPolicyPopup = true;
    },
    openPrivacyPolicy() {
      window.open(
        "https://static.dver.co.kr/privacy-terms/latest.pdf ",
        "_blank"
      );
    },
    changeStatus() {
      this.carrier.ischeck = !this.carrier.ischeck;
      if (this.carrier.ischeck) {
        this.step3Content.previousDeliveryPlatform = null;
      }
    },
    checkValid(isValid) {
      if (!isValid) {
        return true;
      }
      if (this.step2Content.frequentSendGoods) {
        return false;
      } else if (!this.step2Content.frequentSendGoods) {
        if (this.isSelectPathway) {
          return false;
        } else return true;
      }
    },
    cardRoute(type) {
      if (type === "card") {
        this.openRegisterCardModal = true;
      }
      if (type === "faq") {
        return this.$router.push("/services/faq");
      }
      if (type === "deliveryFee") {
        return window.open(
          "https://dvercorp-co-kr.imgix.net/dver/notice/230119_%E1%84%83%E1%85%B5%E1%84%87%E1%85%A5%20%E1%84%87%E1%85%A2%E1%84%89%E1%85%A9%E1%86%BC%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%8B%E1%85%B5%E1%86%B7%20%E1%84%8B%E1%85%A1%E1%86%AB%E1%84%82%E1%85%A2.png"
        );
      }
      if (type === "chatbot") {
        channelTalk.openChat();
      }
      if (type === "companyInfo") {
        this.step = 6;
      }
    },

    //가입경로 선택
    checkPathway(index, value) {
      if (this.selectJoinWay === "none") {
        this.options[index].ischeck = true;
        this.selectJoinWay = value;
        this.preSelect = index;
      } else if (this.selectJoinWay === value) {
        this.preSelect = "";
        this.options[index].ischeck = false;
        this.selectJoinWay = "none";
      } else {
        this.options[this.preSelect].ischeck = false;
        this.options[index].ischeck = true;
        this.selectJoinWay = value;
        this.preSelect = index;
      }
    },

    //step3 다음 버튼 disabled
    isPass(isValid) {
      if (!isValid) {
        return true;
      } else if (isValid) {
        if (this.selectJoinWay === "none") {
          return true;
        } else {
          return false;
        }
      }
    },

    //이전버튼
    prev() {
      if (this.step === 1) {
        return this.$router.push("/join/intro");
      }
      this.step = this.step - 1;
      window.scrollTo(0, 0);
    },

    //다음버튼
    next() {
      if (this.step === 1) {
        this.step1Content.companyName = this.customTrim(
          this.step1Content.companyName
        );
        this.step1Content.name = this.customTrim(this.step1Content.name);
      }
      if (this.step === 2) {
        this.step2Content.frequentSendGoods =
          this.step2Content.frequentSendGoods &&
          this.customTrim(this.step2Content.frequentSendGoods);
      }
      if (this.step === 3) {
        if (this.step3Content.recommender) {
          this.step3Content.recommender = this.customTrim(
            this.step3Content.recommender
          );
        }
        if (this.step3Content.etc) {
          this.step3Content.etc = this.customTrim(this.step3Content.etc);
        }
        if (this.step3Content.previousDeliveryPlatform) {
          this.step3Content.previousDeliveryPlatform = this.customTrim(
            this.step3Content.previousDeliveryPlatform
          );
        }
      }
      this.step = this.step + 1;
      this.progressLibraryOption.currentStep = this.step - 1;
      window.scrollTo(0, 0);
    },

    //배송 물품 선택
    checkItem(value) {
      const result = this.step2Content.selectItem.filter(
        (item) => item === value
      );
      if (result.length > 0) return true;
      return false;
    },

    selectDeliveryItem(value) {
      if (this.step2Content.selectItem.includes(value)) {
        for (var i = 0; i < this.step2Content.selectItem.length; i++) {
          if (this.step2Content.selectItem[i] === value) {
            this.step2Content.selectItem.splice(i, 1);
            i--;
          }
        }
      } else {
        this.step2Content.selectItem.push(value);
      }

      if (this.step2Content.selectItem.length > 0) {
        this.isSelectPathway = true;
      } else {
        this.isSelectPathway = false;
      }
    },

    //약관 링크로 이동
    openTos(type) {
      switch (type) {
        case "services":
          return window.open("/tos/services.html");
        case "privacy":
          return window.open("/tos/privacy.html");
        default:
          return alert("올바르지 않은 요청입니다");
      }
    },

    //사업자등록증 이미지 업로드 관련
    extension(val) {
      // return val.match(/[.]/);
      return val.split(".").pop().toLowerCase();
    },
    selectFile() {
      document.getElementById("file").click();
    },
    onFileChange(e) {
      this.imageLoading = true;
      const file = e.target.files[0];
      const allowedExtension = ["jpg", "png", "gif", "jpeg"];

      if (allowedExtension.indexOf(this.extension(file.name)) === -1) {
        this.imageLoading = false;
        return alert("이미지파일만 업로드 가능합니다");
      }

      const form = new FormData();
      form.append("image", file);

      const progressEvt = {
        onUploadProgress: (evt) => {
          const percent = Math.round((evt.loaded * 100) / evt.total);
          this.fileUploadProcess = `파일업로드 ... ${percent}%`;
        }
      };

      axios
        .post("/images/corp-license", form, {
          progressEvt,
          headers: {
            bypass: true
          }
        })
        .then((result) => {
          this.fileUploadProcess = file.name;
          this.vatInfo.licenseImage = result.data.url;
          this.imageLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.fileUploadProcess = "이미지파일 첨부가능";
          this.vatInfo.licenseImage = "";
        });
    }
  },
  mounted() {}
};
